import React, { useState } from 'react';
import { addressesEqual, formatAddress } from '../utils/address';
import './UserSelector.css';

const UserSelector = ({ users, selectedUser, onSelectUser, onClearUser, loading }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredUsers = users.filter((user) =>
    user.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="user-selector ui-panel">
      <div className="user-selector-header ui-panel-header">
        <h2>User Accounts</h2>
        <div className="user-selector-header-meta">
          <span className="user-count ui-count-chip">
            {users.length} {users.length === 1 ? 'user' : 'users'}
          </span>
          {selectedUser && onClearUser && (
            <button type="button" className="clear-user-btn ui-btn ui-btn--ghost" onClick={onClearUser}>
              Clear
            </button>
          )}
        </div>
      </div>

      <div className="user-search">
        <label htmlFor="user-search-input" className="visually-hidden">
          Search by address
        </label>
        <span className="user-search-icon" aria-hidden="true" />
        <input
          id="user-search-input"
          type="text"
          placeholder="Search by address"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
          aria-label="Search by address"
        />
      </div>

      <div
        className="user-list"
        role="listbox"
        aria-label="User accounts"
        aria-busy={loading && users.length === 0}
      >
        {loading && users.length === 0 ? (
          <div className="user-list-skeleton" role="status" aria-label="Loading users">
            {Array.from({ length: 6 }, (_, index) => (
              <div className="user-item-skeleton" key={index}>
                <span className="ui-skeleton user-item-skeleton-short" />
                <span className="ui-skeleton user-item-skeleton-full" />
              </div>
            ))}
          </div>
        ) : filteredUsers.length === 0 ? (
          <div className="empty-state">No users found</div>
        ) : (
          <>
            <div className="user-list-meta" aria-live="polite">
              {filteredUsers.length} {filteredUsers.length === 1 ? 'match' : 'matches'}
            </div>
            {filteredUsers.map((userAddress) => {
              const selected = addressesEqual(selectedUser, userAddress);
              return (
                <button
                  key={userAddress}
                  type="button"
                  onClick={() => onSelectUser(userAddress)}
                  className={`user-item${selected ? ' selected' : ''}`}
                  role="option"
                  aria-selected={selected}
                >
                  <div className="user-address">
                    <span className="address-short">{formatAddress(userAddress)}</span>
                    <span className="address-full" title={userAddress}>{userAddress}</span>
                  </div>
                </button>
              );
            })}
          </>
        )}
      </div>
    </div>
  );
};

export default UserSelector;
